<template>
  <div class="folder">
    {{ resource.name }}
    <slot />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  mixins: [ editable ]
}
</script>
